export function formatAddonRupee(amount: number | null | undefined): string {
    if (amount === null || amount === undefined || Number.isNaN(amount)) {
        return '—';
    }
    const roundedAmount = Math.round(amount);
    return `₹${roundedAmount.toLocaleString('en-IN', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    })}`;
}

export function formatAddonDisplayName(apiName: string): string {
    if (!apiName) return '';
    return apiName
        .split(/[_\s]+/)
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
}
